// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ax-comment {
  display: grid;
  grid-template-columns: auto 1fr;
  gap: 10px;
  border-bottom: 1px dashed lightgrey;
  padding: 10px 0;
}
.ax-comment ion-avatar {
  width: 32px;
  height: 32px;
}
.ax-comment-user {
  margin-bottom: 10px;
}
.ax-comment-user * {
  margin: 0;
  color: var(--ion-color-medium);
}
.ax-comment-answer {
  margin-left: 30px;
  display: block;
  position: relative;
}
.ax-comment-answer > ion-icon {
  transform: rotate(180deg);
  position: absolute;
  left: -20px;
  top: 20px;
}`, "",{"version":3,"sources":["webpack://./src/app/components/ax-comment/ax-comment.component.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,+BAAA;EACA,SAAA;EACA,mCAAA;EACA,eAAA;AACF;AACE;EACE,WAAA;EACA,YAAA;AACJ;AAEE;EACE,mBAAA;AAAJ;AAEI;EACE,SAAA;EACA,8BAAA;AAAN;AAWA;EACE,iBAAA;EACA,cAAA;EACA,kBAAA;AATF;AAWE;EACE,yBAAA;EACA,kBAAA;EACA,WAAA;EACA,SAAA;AATJ","sourcesContent":[".ax-comment {\n  display: grid;\n  grid-template-columns: auto 1fr;\n  gap: 10px;\n  border-bottom: 1px dashed lightgrey;\n  padding: 10px 0;\n\n  ion-avatar {\n    width: 32px;\n    height: 32px;\n  }\n\n  &-user {\n    margin-bottom: 10px;\n\n    * {\n      margin: 0;\n      color: var(--ion-color-medium);\n    }\n  }\n\n  &-comment {\n    //display: grid;\n    //grid-template-columns: 1fr auto;\n    //gap: 20px 20px;\n  }\n}\n\n.ax-comment-answer {\n  margin-left: 30px;\n  display: block;\n  position: relative;\n\n  > ion-icon {\n    transform: rotate(180deg);\n    position: absolute;\n    left: -20px;\n    top: 20px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
